// src/components/dashboard/AddItineraryModal.js
// Updated: 10/17/2025 10:50 AM

import React, { useState } from 'react';
import { db } from '../../firebase/config';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import toast from 'react-hot-toast';
import Spinner from '../common/Spinner';

const AddItineraryModal = ({ familyId, eventId, onClose }) => {
  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [locationName, setLocationName] = useState('');
  const [address, setAddress] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const itineraryCollectionRef = collection(db, `families/${familyId}/events/${eventId}/itinerary`);
      await addDoc(itineraryCollectionRef, {
        title,
        date: new Date(date),
        time,
        locationName,
        address,
        description,
        createdAt: serverTimestamp(),
      });

      toast.success('Itinerary item added!');
      onClose(); // Close the modal
    } catch (error) {
      console.error("Error adding itinerary item: ", error);
      toast.error('Failed to add item.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
        <div className="p-6 border-b">
          <h3 className="text-xl font-semibold text-neutral-gray">Add Itinerary Item</h3>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
            <div>
              <label htmlFor="title" className="block text-sm font-medium text-gray-700">Title (e.g., "Saturday BBQ")</label>
              <input type="text" id="title" value={title} onChange={(e) => setTitle(e.target.value)} required className="mt-1 w-full border-gray-300 rounded-md shadow-sm"/>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="date" className="block text-sm font-medium text-gray-700">Date</label>
                <input type="date" id="date" value={date} onChange={(e) => setDate(e.target.value)} required className="mt-1 w-full border-gray-300 rounded-md shadow-sm"/>
              </div>
              <div>
                <label htmlFor="time" className="block text-sm font-medium text-gray-700">Time (e.g., "1:00 PM - 4:00 PM")</label>
                <input type="text" id="time" value={time} onChange={(e) => setTime(e.target.value)} required className="mt-1 w-full border-gray-300 rounded-md shadow-sm"/>
              </div>
            </div>
             <div>
              <label htmlFor="locationName" className="block text-sm font-medium text-gray-700">Location Name (e.g., "Central Park Pavilion")</label>
              <input type="text" id="locationName" value={locationName} onChange={(e) => setLocationName(e.target.value)} required className="mt-1 w-full border-gray-300 rounded-md shadow-sm"/>
            </div>
             <div>
              <label htmlFor="address" className="block text-sm font-medium text-gray-700">Address</label>
              <input type="text" id="address" value={address} onChange={(e) => setAddress(e.target.value)} required className="mt-1 w-full border-gray-300 rounded-md shadow-sm"/>
            </div>
            <div>
              <label htmlFor="description" className="block text-sm font-medium text-gray-700">Description (Optional)</label>
              <textarea id="description" value={description} onChange={(e) => setDescription(e.target.value)} rows="3" className="mt-1 w-full border-gray-300 rounded-md shadow-sm"></textarea>
            </div>
          </div>
          <div className="p-6 bg-gray-50 rounded-b-lg flex justify-end items-center gap-4">
            <button type="button" onClick={onClose} className="px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50">
              Cancel
            </button>
            <button type="submit" disabled={loading} className="px-4 py-2 bg-success text-white rounded-md hover:bg-green-700 text-sm font-medium disabled:opacity-50 flex items-center">
              {loading ? <Spinner size="sm" /> : 'Save Item'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddItineraryModal;